export enum RemindBefore {
  doNotNotify = 0,
  oneday = 1,
  twodays = 2,
  threedays = 3,
  oneweek = 4,
  onemonth = 5,
  custom = 6,
}
